import { OptionDto } from "@/dtos";
import { QuotaType } from "@/helpers/types";

const quotaTypes = [
    { value: QuotaType.RECHARGE, label: 'Recarga' },
    { value: QuotaType.DISCHARGE, label: 'Descarga' },
] as OptionDto[];

export const getQuotaTypeOptions = (): OptionDto[] => {
    return quotaTypes;
}

export const getQuotaTypeOption = (value?: number): OptionDto => {
    return quotaTypes.find((x) => x.value == value) ?? quotaTypes[0];
}

export const getQuotaTypeLabel = (value: number): string => {
    return quotaTypes.find((x) => x.value == value)?.label ?? quotaTypes[0].label;
}